import React from "react";
import { Grid } from "@material-ui/core";
import "./register.css";
import { convertUnixToDateTime, formatCurrencyUSD } from "../../util";
import { Navbar } from "reactstrap";
import { withRouter } from "react-router-dom";

const Congratulations = (props) => {
  const { transactionDetails, user, selectedCompanies } =
    props.location.state || {};

  const handleNavigation = () => {
    window.location.href = "/";
  };
  return (
    <React.Fragment>
      <Navbar className={"NavBar"}>
        <div onClick={handleNavigation} style={{ cursor: 'pointer'}}>
          <img src="/SAR-Logo-White.png" className={"SARLogo"} alt="SAR" />
        </div>
      </Navbar>
      <div className={"NavDivider"} />
      <div className="congratulations-container">
        <h2 className="congratulations-header">
          Congratulations, {user.firstName} {user.lastName}!
        </h2>
        <div className="congratulations-content">
          You have successfully registered for an SAR ACE Alert&reg; notification.{" "}
          {transactionDetails && transactionDetails.amount ? (
            <span>
              
              Your licensing fees amounting to, {" "}
              {formatCurrencyUSD(transactionDetails.amount / 100)}, 
              {" "}have been paid and processed by SAR for the corresponding companies listed below.{" "}
            </span>
          ) : null}
          You will be receiving an e-mail to {user.email} shortly with on-boarding instructions to your ACE Alert&reg; subscription.
          Please contact us directly by e-mailing us at info@sarlit.com or calling 202-436-9994 if you do not receive your on-boarding e-mail.
        </div>
      </div>
      <Grid container style={{ justifyContent: "center", color: "#fff" }}>
        <Grid item xs={12} sm={8} md={6}>
          <div style={{ margin: "0 8%" }}>
            <Grid container>
              <Grid item xs={5} sm={5} md={5}>
                <div>Selected Companies</div>
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                {selectedCompanies.map((company, index) => {
                  return (
                    <div
                      key={index}
                      style={{ marginBottom: "1rem" }}
                    >{`${company.companyName} (${company.market}:${company.symbol})`}</div>
                  );
                })}
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default withRouter(Congratulations);



// WEBPACK FOOTER //
// ./src/components/Register/congratulations.jsx